import { TypeOfProduct } from "./type-of-product.model";
import { Aircraft } from "./aircraft.model";

/**
 *
 */
export class AircraftType {
  /**
   *
   */
  aircraftTypeId: number;
  /**
   *
   */
  aircraftTypeName: string;
  /**
   *
   */
  dimensionLength: number;
  /**
   *
   */
  dimensionWidth: number;
  /**
   *
   */
  dimensionHeight: number;
  /**
   *
   */
  typeOfProducts?: Array<TypeOfProduct>;
  aircrafts: Aircraft[];

  constructor (
    aircraftTypeName?: string,
    dimensionLength?: number,
    dimensionWidth?: number,
    dimensionHeight?: number
  ) {
    this.aircraftTypeName = aircraftTypeName;
    this.dimensionLength = dimensionLength;
    this.dimensionWidth = dimensionWidth;
    this.dimensionHeight = dimensionHeight;
  }
}
